import React from 'react';
import {selectedStaff} from '../../hooks/useGetStaffId';
import {GetAdvisors_staff} from '../../schema-types/GetAdvisors';

export const handleStaffUpdate = (
  advisorStaff: GetAdvisors_staff,
  setStaff: React.Dispatch<React.SetStateAction<selectedStaff | null>>
): void => {
  const fullName = `${advisorStaff.firstName} ${advisorStaff.lastName}`;
  if (advisorStaff) {
    const existingStaff = JSON.parse(localStorage.getItem('dashboardStaff') || '{}');

    const updatedStaff = {
      ...existingStaff,
      id: advisorStaff.id,
      email: advisorStaff.email,
      name: fullName,
    };

    localStorage.setItem('dashboardStaff', JSON.stringify(updatedStaff));

    setStaff(updatedStaff);
  }
};
